import i18n from '@/i18n';

export default [
  {
    text: i18n.t('enums.OpcaoIntegracaoOmieEnum.nenhuma'),
    value: null,
  },
  {
    text: i18n.t('enums.OpcaoIntegracaoOmieEnum.omie'),
    value: 'Omie',
  },
];
